import React from "react";
export const JointBarFractureReportSchema = {
  typeOfInspection: [
    [{ title: "PERIODIC JOINT INSPECTION (213.119[g][5][i])", id: "tofinsp", tickBox: true }],
    [{ title: "TRACK INSPECTION (213.233)", id: "tofinsp", tickBox: true }],
    [{ title: "TURNOUT INSPECTION (213.235)", id: "tofinsp", tickBox: true }],
  ],
  generalInfoSection: [
    [{ title: "TANGENT", id: "tangent", tickBox: true }],
    [
      {
        title: "CURVE",
        id: "curve",
        otherValId: "degree",
        tickBox: true,
        forceOther: true,
        otherPostComp: "degrees",
      },
      { title: "LOW/INNER RAIL", id: "lirail", tickBox: true },
      { title: "" },
    ],
    [
      { title: "IN SPIRAL", id: "inspiral", tickBox: true },
      { title: "HIGH/OUTER RAIL", id: "horail", tickBox: true },
    ],

    [{ title: "RAIL SECTION(S)", id: "toad" }],

    [
      {
        title: "ANNUAL JOINT INSPECTION FREQUENCY FOR THIS SEGMENT:",
        isTitle: true,
        titleStyle: { fontWeight: "200", fontSize: "18px" },
      },
      { title: "1x", id: "toad_1rr_1rri", tickBox: true },
      { title: "2x", id: "toad_1rr_1rri", tickBox: true },
      { title: "3x", id: "toad_1rr_1rri", tickBox: true },
      { title: "4x", id: "toad_1rr_1rri", tickBox: true },
      { title: "OTHER", id: "toad_1rr_1rri", otherValId: "com", tickBox: true },
    ],

    [{ title: "DATE OF LAST JOINT INSPECTION", id: "dateolji" }],
  ],
  barType: [
    [
      { title: "STANDARD", id: "standard", tickBox: true },
      { title: "INSULATED", id: "insulated", tickBox: true },
      { title: "COMPROMISE", id: "compromise", tickBox: true },
      { title: "" },
    ],
    [
      { title: "NUMBER OF HOLES:", isTitle: true },
      { title: "4", id: "nofholes", tickBox: true },
      { title: "5", id: "nofholes", tickBox: true },
      { title: "6", id: "nofholes", tickBox: true },
      { title: "7", id: "nofholes", tickBox: true },
      { title: "8", id: "nofholes", tickBox: true },
    ],
  ],
  fieldBroken: [
    [
      { title: "CENTER", id: "center", tickBox: true },
      { title: "INNER BOLT", id: "innerbolt", tickBox: true },
      { title: "OTHER", id: "other", tickBox: true, otherValId: "com1" },
    ],
  ],

  fieldCracked: [
    [
      { title: "TOP CENTER", id: "topcenter", tickBox: true },
      { title: "Inches", id: "com2", tickBoxBindingId: "topcenter" },
    ],

    [
      { title: "BOTTOM CENTER", id: "botcenter", tickBox: true },
      { title: "Inches", id: "com3", tickBoxBindingId: "botcenter" },
    ],

    [
      { title: "INNER BOLT HOLE", id: "innbothole", tickBox: true },
      { title: "Inches", id: "com4", tickBoxBindingId: "innbothole" },
    ],

    [
      { title: "OTHER BOLT HOLE", id: "othbothole", tickBox: true },
      { title: "Inches", id: "com5", tickBoxBindingId: "othbothole" },
    ],

    [
      { title: "OTHER", id: "otherfsidebar", otherValId: "com6", tickBox: true },
      { title: "Inches", id: "com7", tickBoxBindingId: "otherfsidebar" },
    ],
  ],

  gageBroken: [
    [
      { title: "CENTER", id: "center01", tickBox: true },
      { title: "INNER BOLT", id: "inbhole01", tickBox: true },
      { title: "OTHER", id: "other01", tickBox: true, otherValId: "com8" },
    ],
  ],

  gageCracked: [
    [
      { title: "TOP CENTER", id: "topcenter2", tickBox: true },
      { title: "Inches", id: "com9", tickBoxBindingId: "topcenter2" },
    ],

    [
      { title: "BOTTOM CENTER", id: "botcenter2", tickBox: true },
      { title: "Inches", id: "com10", tickBoxBindingId: "botcenter2" },
    ],

    [
      { title: "INNER BOLT HOLE", id: "innbothole2", tickBox: true },
      { title: "Inches", id: "com11", tickBoxBindingId: "innbothole2" },
    ],

    [
      { title: "OTHER BOLT HOLE", id: "othbothole2", tickBox: true },
      { title: "Inches", id: "com12", tickBoxBindingId: "othbothole2" },
    ],

    [
      { title: "OTHER", id: "othergsidebar", tickBox: true, otherValId: "com13" },
      { title: "Inches", id: "com14", tickBoxBindingId: "othergsidebar" },
    ],
  ],

  gapBetween: [
    [{ title: "GAP BETWEEN RAIL ENDS", isTitle: true, id: "id1" }, { title: "Inches", id: "gapbetrail" }, { title: "" }, { title: "" }],
  ],

  railEnd: [
    [
      { title: "NORTH RAIL END", id: "north", tickBox: true },
      { title: "EAST RAIL END", id: "north", tickBox: true },
      { title: "INCHES HIGH", id: "inhigh" },
      { title: "INCHES LONG", id: "inlong" },
    ],

    [
      { title: "SOUTH RAIL END", id: "south", tickBox: true },
      { title: "WEST RAIL END", id: "south", tickBox: true },
      { title: "INCHES HIGH", id: "inhigh2" },
      { title: "INCHES LONG", id: "inlong2" },
    ],
  ],

  treadMismatch: [
    [{ title: "TREAD MISMATCH", isTitle: true, id: "id1" }, { title: "INCHES", id: "treadmismatch" }, { title: "" }, { title: "" }],
  ],

  jointVertical: [
    [{ title: "JOINT VERTICAL MOVEMENT", isTitle: true, id: "id1" }, { title: "INCHES", id: "vertjoimove" }, { title: "" }, { title: "" }],
  ],

  jointInCurve: [[{ title: "IF JOINT IN CURVE or SPIRAL", isTitle: true, id: "id1" }]],
  gageRamp: [
    [
      { title: "GAGE RAMP", isTitle: true },
      { title: "INCHES OUT", id: "gageramp4" },
      { title: "INCHES LONG", id: "gageramp5" },
      { title: "" },
    ],
  ],
  gageMismatch: [
    [{ title: "GAGE MISMATCH", isTitle: true, id: "id1" }, { title: "INCHES", id: "gagemismatch4" }, { title: "" }, { title: "" }],
  ],

  jointLateral: [
    [
      { title: "JOINT LATERAL MOVEMENT", isTitle: true, id: "id1" },
      { title: "INCHES", id: "jointlateralMove" },
      { title: "" },
      { title: "" },
    ],
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/SCFE/JointBarFractureReport/JointBarFractureReportSchema.jsx